import DeviceLoanApprovalTable from "./ApprovalTable";

const RegionDeviceLoanApproval = () => <DeviceLoanApprovalTable level="region" />;

export default RegionDeviceLoanApproval;
